﻿$.fn.dxCtrlLoginSupport = function custom_dxCtrlLoginSupport(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlloginsupport dx-ctrl");
        this.createInstance(new cdxCtrlLoginSupport(this, option));
    }
    return this;
}

window.cdxCtrlLoginSupport = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();
        container.css({
            "display": "flex",
            //"align-items": "center",
            "padding-top": "100px",
            "justify-content": "center",
            "height": "100%",
            "width": "100%"
        })
        $DivContainer = $("<div style='width:300px;'/>").appendTo(container)

        var img = parametre.img
        var nom = parametre.nom

        var $DivImg = $("<div style='text-align:center;'/>").appendTo($DivContainer)
        var $Img = $("<img src='" + img + "' style='width:70px'/>").appendTo($DivImg)

        var $Div = $("<div class='dx-theme-accent-as-background-color'/>").appendTo("body");
        backgroundcolorAccent = $Div.css("background-color");
        $Div.remove();
        var $DivGlitchWrapper = $("<div class='glitch-wrapper'/>").appendTo($DivImg)
        $("<div class='glitch' data-glitch='glitch'>Support " + nom + "</div>").appendTo($DivGlitchWrapper)


        var $DivConnexion = $("<div/>").appendTo($DivContainer);
        $("<div style='text-align:center;padding-top:20px;'>Connectez vous avec le login et mot de passe de votre application</div>").appendTo($DivConnexion)

        $("<br/>").appendTo($DivConnexion)
        $("<br/>").appendTo($DivConnexion)
        dxAdrEmail = $("<div/>").appendTo($DivConnexion).dxTextBox({
            labelMode: 'floating',
            label: "Adresse email",
            value: ((typeof option.adresseEmail != 'undefined') ? option.adresseEmail : ""),
            placeholder: "Adresse email de connexion..." + String.fromCharCode(160),
            width: "100%",
            mode: "email",
            onKeyUp: function (e) {
                if (e.event.keyCode == 13) {
                    if (!dxPwd.option("value") || dxPwd.option("value").length == 0) { dxPwd.focus(); }
                }
            }
        }).dxTextBox("instance")
        $("<br/>").appendTo($DivConnexion)
        $("<br/>").appendTo($DivConnexion)
        dxPwd = $("<div/>").appendTo($DivConnexion).dxTextBox({
            labelMode: 'floating',
            label: "Mot de passe",
            value: "",
            placeholder: "Mot de passe..." + String.fromCharCode(160),
            width: "100%",
            mode: 'password',
            buttons: [{
                focusStateEnabled: false,
                name: 'showpwd',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    hint: "Révéler/cacher le texte",
                    focusStateEnabled: false,
                    stylingMode: 'text',
                    onClick() {
                        if (dxPwd.element().find("input").hasClass("txtPassword")) {
                            dxPwd.element().find("input").removeClass("txtPassword")
                            dxPwd.option("mode", "")
                        } else {
                            dxPwd.element().find("input").addClass("txtPassword")
                            dxPwd.option("mode", "password")
                        }
                    },
                },
            }],
            onKeyUp: function (e) {
                if (e.event.keyCode == 13 && dxPwd.option("value") && dxPwd.option("value").length > 0 && dxAdrEmail.option("value") && dxAdrEmail.option("value").length > 0) { dxBtConnect.element().click(); }
            },
            onContentReady: function (e) {
                e.component.element().find("input").addClass("txtPassword")
            }
        }).dxTextBox("instance")

        var $Divoubli = $("<div style='text-align:right;padding-top:0px'/>").appendTo($DivConnexion)
        var $a = $("<a href='javascript:void(0)' style='font-size:10px'>Oubli mot de passe</a>").appendTo($Divoubli)
        $a.on("click", function () {
            option.onDemandeReinitPwd()
        });

        var $DivBt = $("<div style='text-align:right;padding-top:30px'/>").appendTo($DivConnexion)
        var dxBtConnect = $("<div/>").appendTo($DivBt).dxButton({
            text: "Se connecter",
            focus: true,
            onClick: function (e) {
                option.bddCtrl.mAjaxCall({
                    command: "connectsupport",
                    adresse_email: dxAdrEmail.option("value"),
                    pwd: dxPwd.option("value")
                }, function (data) {
                    if (typeof data.id_compte_client == "undefined") {
                        mNotify("Impossible de vous connecter.<br/>Veuillez vérifier votre saisie.", "warning", 6000)
                    } else {
                        option.onValidateCnx(data.id_compte_client, data.id_utilisateur)
                    }
                })
            }
        }).dxButton("instance");
    }

    mConstruit();

}